import makeStyles from '@material-ui/core/styles/makeStyles';
import { Form, Formik } from 'formik';
import moment from 'moment';
import React, { useCallback, useEffect } from 'react';
import { useObservable } from 'react-use-observable';
import { sendEventToGA } from 'v2/helpers/analytics';
import { getDifferenceInYears } from 'v2/helpers/date';
import salesService from 'v2/services/sales/general';

import Advanced from './Advanced';
import BasicFilter from './Basic';
import { InitialFilter } from './interfaces';
import Result from './Result';
import FilterSchema from './validations';

import type IFilter from './interfaces';
import type { FormikProps } from 'formik';

const useStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    background: '#ffff',
    borderRadius: 4,
    boxShadow: '0 1px 0 0 rgba(0,0,0,0.07)',
    width: '100%',
    zIndex: 16,
  },
  '@media screen and (min-width: 600px)': {
    root: {
      padding: theme.spacing(2),
      background: '#ffff',
      borderRadius: 4,
      boxShadow: '0 1px 0 0 rgba(0,0,0,0.07)',
      zIndex: 16,
      width: '100%',
      marginBottom: theme.spacing(2),
    },
  },
}));

const Filter = () => {
  const classes = useStyle({});
  const [showAdvancedResult] = useObservable(() => salesService.getShowAdvancedResult(), []);
  const [advanced] = useObservable(() => salesService.getFilterIsAdvanced(), []);

  useEffect(() => {
    salesService.loadProducts();
  }, []);

  const onCloseAdvanced = useCallback(() => salesService.setFilterIsAdvanced(false), []);

  const handleValuesTracking = useCallback((values: IFilter) => {
    const [startDate, endDate] = values.date;
    const isOneYearOrBigger = getDifferenceInYears(moment(endDate, 'DD/MM/YYYY'), moment(startDate, 'DD/MM/YYYY')) >= 1;
    if (isOneYearOrBigger) {
      sendEventToGA({
        category: 'Sales - Filter',
        label: 'Filter by 1+ years',
        action: 'Filtering',
      });
    }
  }, []);

  const onSubmit = useCallback(
    (values: IFilter, { setSubmitting, resetForm }: FormikProps<IFilter>) => {
      handleValuesTracking(values);
      salesService.setFilter({ ...values, ...{ advanced } });
      resetForm({ values });
      setSubmitting(false);
      if (advanced) onCloseAdvanced();
    },
    [advanced, onCloseAdvanced, handleValuesTracking]
  );

  return (
    <Formik initialValues={InitialFilter} validationSchema={FilterSchema} onSubmit={onSubmit}>
      {() => (
        <Form id='sales-filter' className={classes.root}>
          {!showAdvancedResult && <BasicFilter />}
          <Advanced />
          {showAdvancedResult && <Result />}
        </Form>
      )}
    </Formik>
  );
};
export default Filter;
